// @ts-nocheck

import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Slider from 'react-slick';

import Ticket from './ticket/ticket.tsx';
import Pagination from './pagination/pagination.tsx';
import { T } from '@/v2/helpers/i18n';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './slickSlide.scss';
import styles from './items.module.scss';

import Footer from './ticket/footer/footer';
import { EventItemsModel, orderItems } from '@/v2/models/eventItemsModel.ts';
import { isTicket } from '@/v2/models/ticketModel.ts';
import { isProduct } from '@/v2/models/productModel.ts';
import { RootContext, StateContext } from '@/root/root.provider.tsx';
import { MultiEventEnvelopeModel, RedemptionAvailabilityModel } from '@/v2/models/multiEventEnvelopeModel.ts';
import Product from '@/v2/wallet/items/product/product.tsx';

type Props = {
  envelope: MultiEventEnvelopeModel;
  eventItems: EventItemsModel;
  redemptionAvailability: RedemptionAvailabilityModel;
} & T;

export class Items extends Component<Props> {
  static contextType: React.Context<StateContext> = RootContext;

  slider: any;

  render() {
    const { envelope, eventItems, redemptionAvailability } = this.props;
    const { activeToken, tmOrderUrl } = envelope;
    const event = eventItems.event;
    const tickets = eventItems.tickets;
    const products = eventItems.products;
    const items = orderItems([...tickets, ...products]);

    const settings = {
      className: 'tickets-slider',
      dots: false,
      infinite: false,
      speed: 500,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '24px',
    };

    return (
      <section className={styles.items}>
        <div className={styles.items}>
          <Slider ref={(c) => (this.slider = c)} {...settings}>
            {items.map((item: TicketModel | ProductModel, index) => (
              <div className={`${styles.items} ${styles.itemPagination}`} key={index}>
                {isTicket(item) &&
                    <Ticket activeToken={activeToken} ticket={item} event={event} redemptionAvailability={redemptionAvailability} index={index}/>}
                {isProduct(item) && <Product product={item} index={index}/>}
                <Pagination
                  index={index}
                  total={items.length}
                  next={() => this.slider.slickNext()}
                  prev={() => this.slider.slickPrev()}
                />
              </div>
            ))}
          </Slider>
          <div>
            <Footer activeToken={activeToken} event={event} redemptionAvailability={redemptionAvailability} tmOrderUrl={tmOrderUrl}/>
          </div>
        </div>
      </section>
    );
  }
}

export default withTranslation('translation')(Items);
